var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "29px",
    viewBox: "0 0 22 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B89864DA-DF66-4C4C-A0A3-CEB850A818E8@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDEA7-web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mais-web-1",
    transform: "translate(-968.000000, -154.000000)",
    fill: "#282850",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Zgody",
    transform: "translate(928.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock-alt-1-lock",
    transform: "translate(40.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,28.8 L3.6,28.8 C1.6117749,28.8 0,27.1882251 0,25.2 L0,18 C0,16.0117749 1.6117749,14.4 3.6,14.4 L18,14.4 C19.9882251,14.4 21.6,16.0117749 21.6,18 L21.6,25.2 C21.6,27.1882251 19.9882251,28.8 18,28.8 Z M3.6,16.8 C2.9372583,16.8 2.4,17.3372583 2.4,18 L2.4,25.2 C2.4,25.8627417 2.9372583,26.4 3.6,26.4 L18,26.4 C18.6627417,26.4 19.2,25.8627417 19.2,25.2 L19.2,18 C19.2,17.3372583 18.6627417,16.8 18,16.8 L3.6,16.8 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,16.8 C16.1372583,16.8 15.6,16.2627417 15.6,15.6 L15.6,7.2 C15.6,4.5490332 13.4509668,2.4 10.8,2.4 C8.1490332,2.4 6,4.5490332 6,7.2 L6,15.6 C6,16.2627417 5.4627417,16.8 4.8,16.8 C4.1372583,16.8 3.6,16.2627417 3.6,15.6 L3.6,7.2 C3.6,3.2235498 6.8235498,0 10.8,0 C14.7764502,0 18,3.2235498 18,7.2 L18,15.6 C18,15.9182598 17.8735718,16.2234845 17.6485281,16.4485281 C17.4234845,16.6735718 17.1182598,16.8 16.8,16.8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,22.8 C9.4745166,22.8 8.4,21.7254834 8.4,20.4 C8.4,19.0745166 9.4745166,18 10.8,18 C12.1254834,18 13.2,19.0745166 13.2,20.4 C13.2,21.7254834 12.1254834,22.8 10.8,22.8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,25.2 C10.1372583,25.2 9.6,24.6627417 9.6,24 L9.6,21.6 C9.6,20.9372583 10.1372583,20.4 10.8,20.4 C11.4627417,20.4 12,20.9372583 12,21.6 L12,24 C12,24.6627417 11.4627417,25.2 10.8,25.2 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.58b5bf94dfd6203885637fe3b6bd5f8c.svg";
export { ForwardRef as ReactComponent };